import { lookLayers, oneXArt, userPeonArtwork, type LayeredLook } from "../peon-art.ts";
import { DEFAULT_SHIRT, isShirt } from "../../shared/shirts.ts";

/**
 * A peon drawn small (shared/weekly.ts GALLERY_PEON): your peon's model, the mascot without the
 * crown, in their shirt with their hair, beard and accessories over him (PeonLayers' stack), 46x42
 * art pixels at two thirds of a CSS pixel each, so a 3x phone doubles every pixel exactly. The
 * gallery tile's corner wears it on a bronze-edged plate (owner, 2026-10-05: "In gallery, a small
 * version of the peon who did it should be in the corner"); a closed note slip wears it as the
 * author's stamp (owner, 2026-10-05: "it should just be a little stamp of their peon"). The caller
 * names it for a screen reader, or hides it.
 */
export function SmallPeon({ look }: { look: LayeredLook & { shirt?: unknown } }) {
  const shirt = isShirt(look.shirt) ? look.shirt : DEFAULT_SHIRT;
  return (
    <span class="small-peon" data-shirt={shirt}>
      <img class="small-peon-mascot" src={oneXArt(userPeonArtwork(shirt))} alt="" />
      {lookLayers(look, false).map((l) => (
        <img key={l.key} class="small-peon-layer" data-layer={l.key} src={oneXArt(l.src)} alt="" />
      ))}
    </span>
  );
}
